export const appArrowDownIcon = {
    data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 15.6998L6 9.6998L7.4 8.2998L12 12.8998L16.6 8.2998L18 9.6998L12 15.6998Z" fill="currentColor"/></svg>`,
    name: 'arrow-down' as const
};